/*
Sohel 09/24/2023 5155351299 Added Map Field Table
uday 25/025/2023 5155351299 fixed button and table alignments
Sohel 09/29/2023  5155351299 Extended Repository Added Field Description
*/
import React, {useContext, useRef, useEffect, useState} from 'react';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../../components/TableIcons';
import {Button, Grid} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {tempSelectFunc2, filteredCheckedData2} from '../../../../../util/Functions';

function FieldSearchTable({
  handleClose,
  values,
  setFieldValue,
  setTempSelectedRows,
  tempSelectedRows,
  baseRepositoryFieldsData,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const tempUnCheckedRef = useRef();
  const [data, setData] = useState([]);
  const columns = [
    {
      title: 'Field Name',
      field: 'fieldName',
    },
    {
      title: 'Field Label',
      field: 'fieldLabel',
    },
    {
      title: 'Field Description',
      field: 'fieldDescription',
    },
    {
      title: 'Field Type',
      field: 'fieldType',
    },
    {
      title: 'List Type',
      field: 'listType',
    },
    {
      title: 'DB Column Name',
      field: 'tableColumnName',
    },
  ];
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);
  useEffect(() => {
    if (values?.fields?.length > 0) {
      const selectedFields = values?.fields?.map((el) => el?.baseFieldName);
      const rows = baseRepositoryFieldsData
        ?.map((i) => {
          if (selectedFields?.includes(i?.fieldName)) {
            return {
              ...i,
              tableData: {tableData: i?.tableData, checked: true},
            };
          } else {
            return {
              ...i,
              tableData: {tableData: i?.tableData, checked: false},
            };
          }
        })
        .filter((el) => el?.tableData?.checked === false);
      setData(rows);
    } else {
      const data = baseRepositoryFieldsData?.map((el) => {
        return {...el};
      });
      setData(data);
    }
  }, [baseRepositoryFieldsData]);
  return (
    <Grid item xs={12} className="px-3">
      <div className="new-standard-textfields mb-3">
        <div className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-end ml-2">
          <Button
            aria-label="close"
            variant="outlined"
            className={`mr-1 reset-btn ${classes.buttonRoot}`}
            onClick={() => {
              handleClose();
            }}
          >
            Close
          </Button>
          <Button
            aria-label="save"
            variant="outlined"
            className={`ml-1 search-btn ${classes.buttonRoot}`}
            onClick={() => {
              const fieldTypeObj = tempSelectFunc2('baseFieldName', tempUnCheckedRef);
              const [newSelectedRows] = filteredCheckedData2(
                values.fields,
                fieldTypeObj,
                'baseFieldName',
              );
              const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
              setFieldValue('fields', allSelectedRows);
              handleClose();
            }}
          >
            Save
          </Button>
        </div>
      </div>

      <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table new-standard-textfields actions-dropdown-table">
        <GuiTable
          title={''}
          columns={columns}
          icons={tableIcons}
          // tableRef={tableRef}
          onSelectionChange={(rows, row) => {
            if (row?.tableData?.checked) {
              const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
              arr.push({
                ...row,
                baseFieldName: row.fieldName,
                extendedFieldLabel: row.fieldLabel,
                extendedFieldDescription: row.fieldDescription,
                tableData: {
                  ...row.tableData,
                  id: row.fieldName,
                },
              });
              setTempSelectedRows(arr);
            } else {
              tempUnCheckedRef.current.push(row);

              const updatedRows = [...tempSelectedRows]
                .filter((ele) => ele?.baseFieldName !== row?.fieldName)
                .map((ele) => {
                  return {
                    ...ele,
                    tableData: {
                      ...ele.tableData,
                      id: ele.baseFieldName,
                    },
                  };
                });
              setTempSelectedRows(updatedRows);
            }
          }}
          data={data}
          options={{
            search: false,
            toolbar: false,
            toolbarButtonAlignment: 'left',
            selection: true,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            showTextRowsSelected: false,

            headerStyle: {
              fontWeight: 'bold',
            },
          }}
        />
      </div>
    </Grid>
  );
}
export default FieldSearchTable;
